import { create } from 'zustand';
import { ReactNode } from 'react';

export interface Modal {
  id: string;
  title?: string;
  content: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  closable?: boolean;
}

interface ModalStore {
  modals: Modal[];
  open: (modal: Omit<Modal, 'id'>) => string;
  close: (id: string) => void;
  closeAll: () => void;
}

export const useModals = create<ModalStore>((set) => ({
  modals: [],
  open: (modal) => {
    const id = Date.now().toString();
    const newModal = { ...modal, id };
    set((state) => ({
      modals: [...state.modals, newModal]
    }));
    return id;
  },
  close: (id) => set((state) => ({
    modals: state.modals.filter(m => m.id !== id)
  })),
  closeAll: () => set({ modals: [] }),
}));